import React, { useEffect } from "react";
import { NAV } from "constants/scheduling";
import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";
import { withRouter } from "react-router-dom";
import { render } from "@testing-library/react";
import Switch from "react-switch";
import connect from "react-redux/lib/connect/connect";
import * as UserDucks from "ducks/accounts/user";

const { REACT_APP_SCHEDULING_BASE_URL } = process.env;

let oAuthToken;
let company_id;
class SchedulingDashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
      useAlternativeView: false,
    };

    this.oAuthToken = StorageGateway.get("oAuthToken");
    this.company_id = StorageGateway.get("company_id") || StorageGateway.get("nre_company_id");
    this.handleToggleChange = this.handleToggleChange.bind(this);
   
    
    this.handleMessage = this.handleMessage.bind(this);
    this.handleDashboardMessage = this.handleDashboardMessage.bind(this);
  }

  componentWillMount() {
    oAuthToken = StorageGateway.get("oAuthToken");
    company_id = StorageGateway.get("company_id");
    if (!company_id) {
      company_id = StorageGateway.get("nre_company_id");
    }
  }

  fetchData() {
    this.setState({ refresh: true });
    setTimeout(() => this.setState({ refresh: false }));
  }

  handleToggleChange() {
    this.setState(
      (prevState) => ({
        useAlternativeView: !prevState.useAlternativeView,
        refresh: true,
      }),
      () => {
        setTimeout(() => this.setState({ refresh: false }));
      }
    );
  }

  handleMessage(event) {
    const data =
      event.data && typeof event.data !== "object" && JSON.parse(event.data);
    const message = data?.message;
    if (message === "SHIFT_MANAGEMENT_PAGE") {
     
      
      this.props.history.push("/scheduling/shift-management/?route=false");
    }
    if (message === "ROUTE_MANAGEMENT_PAGE") {
      console.log("adas");
      this.props.history.push("/scheduling/shift-management/?route=true");
    }
  }

  handleDashboardMessage(event) {
    const data =
      event.data && typeof event.data !== "object" && JSON.parse(event.data);
    const message = data?.message;
    if (message === "SHIFT_DAHBOARD_PAGE") {
      this.props.history.push("/scheduling/dashboard");
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.handleMessage, false);
    window.addEventListener("message", this.handleDashboardMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
    window.removeEventListener("message", this.handleDashboardMessage);
  }

  render() {
    
    const { companyPermissions } = this.props;
    const iframeSrc = this.state.useAlternativeView
      ? `${REACT_APP_SCHEDULING_BASE_URL}/route-scheduling-dashboard/?oAuthToken=${oAuthToken}&company_id=${company_id}`
      : `${REACT_APP_SCHEDULING_BASE_URL}/scheduling-dashboard/?oAuthToken=${oAuthToken}&company_id=${company_id}`;

    return (
      <TwoColumnLayout
        navInfo={
          this.state.useAlternativeView
            ? NAV.RouteSchedulingDashboardPage
            : NAV.SchedulingDashboardPage
        }
        fetchData={this.fetchData}
        hideFooter={true}
      >
        {companyPermissions && companyPermissions?.jobtraks && (
          <div
            style={{
              display: "flex",
              gap: "5px",
              "margin-right": "10px",
            }}
          >
            <span>Shift</span>
            <Switch
              checked={this.state.useAlternativeView}
              onChange={this.handleToggleChange}
              uncheckedIcon={false}
              checkedIcon={false}
              height={18}
              width={36}
              onColor="#09819A"
            />
            <span>Route</span>
          </div>
        )}
        {!this.state.refresh && (
          <div style={{ height: "calc(100vh - 102px - 46px)" }}>
            <iframe
              id="scheduling"
              title="scheduling-iframe"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ width: "100%", height: "100%" }}
              src={iframeSrc}
            />
          </div>
        )}
      </TwoColumnLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  companyPermissions: UserDucks.companyPermissions(state),
});

export default withRouter(connect(mapStateToProps)(SchedulingDashboardPage));
